import React from 'react';
import { Box, Flex, Heading, Text } from 'pounceV2';
import WarningImg from 'Assets/illustrations/warning.svg';
import { LinkButtonV3 } from 'Components/buttons/LinkButton/LinkButtonV3';
import { Permission } from 'Generated/schema';
import useCheckPermissions from 'Hooks/useCheckPermissions';
import withSEO from 'Hoc/withSEO';
import { useTheme } from '@mui/material';

const PageFailedToFetchV3: React.FC = () => {
  const theme = useTheme();
  const canUserAccessSummary = useCheckPermissions(Permission.SummaryRead);

  return (
    <Flex justify="center" align="center" direction="column">
      <Box mb={10}>
        <img alt="Page crash illustration" src={WarningImg} width="auto" height={350} />
      </Box>
      <Heading mb={2}>Unable to Fetch Data</Heading>
      <Box textAlign="center" color={theme.palette.tokens.content.text.neutral[3]} maxWidth={600}>
        <Text>There was an issue with the network connection. Possible reasons:</Text>
        <Flex
          as="ul"
          sx={{ listStyle: 'disc' }}
          direction="column"
          align="flex-start"
          ml={70}
          mt={2}
        >
          <Text as="li">The request was blocked by a firewall or other security measure.</Text>
          <Text as="li">The server is not responding.</Text>
          <Text as="li" mb={10}>
            Your network connection may be unstable.
          </Text>
        </Flex>
      </Box>
      {canUserAccessSummary && <LinkButtonV3 to="/">Back to somewhere stable</LinkButtonV3>}
    </Flex>
  );
};

export default withSEO({ title: 'Failed to Fetch' })(PageFailedToFetchV3);
